module.exports = __webpack_public_path__ + "img/donut-chart-light-01.16a4a427.jpg";